// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FMFooterLogo_wrapper__T_ra2","line":"FMFooterLogo_line__LBYIy","blueOceanLogo":"FMFooterLogo_blueOceanLogo__3aw8k"};